import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import RootRef from '@material-ui/core/RootRef';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import grey from '@material-ui/core/colors/grey';
import { observer } from 'mobx-react/index';
import { routePage } from '../store/route-page';

// Cell split in two classes to prevent collisions between React Beautiful DnD HoC and others
class InnerCell extends Component {
  render() {
    const { t } = this.props;
    const hide = routePage.orderedAddresses.length === 0;
    const outerStyle = { padding: '4px', backgroundColor: grey[200] };
    const innerStyle = { padding: '8px', backgroundColor: grey[200], border: `2px dashed ${grey[400]}` };
    return (
      <Grid item container direction="column" style={outerStyle}>
        <Grid item style={innerStyle}>
          <Typography variant="body2" align="center">{t('messages.addToList')}</Typography>
          <Hidden xsUp={hide}>
            <Typography variant="body2" align="center">{t('messages.moveAddToList')}</Typography>
          </Hidden>
        </Grid>
      </Grid>
    );
  }
}

InnerCell.propTypes = { t: PropTypes.func.isRequired };

const WrappedInnerCell = withNamespaces()(observer(InnerCell));

class AddToListCell extends Component {
  render() {
    const { provided } = this.props;
    return (
      <RootRef rootRef={provided.innerRef}>
        <Grid container direction="column" {...provided.draggableProps} {...provided.dragHandleProps}>
          <WrappedInnerCell/>
        </Grid>
      </RootRef>
    );
  }
}

AddToListCell.propTypes = { provided: PropTypes.any };

export default AddToListCell;



// WEBPACK FOOTER //
// ./src/components/AddToListCell.js